document.addEventListener('DOMContentLoaded', () => {
    // Media Quieries
    const mobileQuery = window.matchMedia('(max-width: 600px)');

    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    document.querySelectorAll('.swiper-slider').forEach(slider => {
        new Swiper(slider, {
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: slider.querySelector('.swiper-slider-prev'),
                nextEl: slider.querySelector('.swiper-slider-next')
            }
        })
    });

    let sliderCopy = new Swiper('.slider-block-copy', {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        allowTouchMove: false,
        navigation: {
            prevEl: '.slider-block-prev',
            nextEl: '.slider-block-next'
        },
        autoHeight: true,
        breakpoints: {
            600: {
                pagination: {
                    enabled: false
                }
            },
            900: {
                autoHeight: false
            }
        }
    });

    let sliderImages = new Swiper('.slider-block-images', {
        loop: true,
        speed: 700,
        spaceBetween: 20,
        slidesPerView: 1,
        allowTouchMove: false,
        navigation: {
            prevEl: '.slider-block-prev',
            nextEl: '.slider-block-next'
        },
        breakpoints: {
            600: {
                slidesPerView: 1.56,
                pagination: {
                    enabled: false
                }
            }
        }
    });

    let sliderAmenities = new Swiper('.slider-amenities', {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        navigation: {
            prevEl: '.slider-amenities-prev',
            nextEl: '.slider-amenities-next'
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            800: {
                slidesPerView: 3,
            },
            1000: {
                slidesPerView: 4,
            }
        }
    });

    let sliderCards = new Swiper('.slider-cards', {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 26,
        navigation: {
            prevEl: '.slider-cards-prev',
            nextEl: '.slider-cards-next'
        },
        breakpoints: {
            1024: {
                slidesPerView: 2
            },
            1200: {
                slidesPerView: 3
            }
        }
    });

    let sliderReviews = new Swiper('.slider-reviews', {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-reviews-prev',
            nextEl: '.slider-reviews-next'
        },
    });

    let sliderGalleryMain = new Swiper('.slider-gallery-main', {
        loop: true,
        speed: 700,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        initialSlide: 0,
        navigation: {
            prevEl: '.slider-gallery-prev',
            nextEl: '.slider-gallery-next'
        }
    });

    if (document.querySelector('.slider-gallery-sub')) {
        let sliderGallerySub = new Swiper('.slider-gallery-sub', {
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            initialSlide: 1,
            allowTouchMove: false
        });

        sliderGalleryMain.on('slideChange', () => {
            sliderGallerySub.slideTo((sliderGalleryMain.realIndex + 1) % sliderGalleryMain.slides.length);
        });
    }


    let sliderTimeline = new Swiper('.slider-timeline', {
        loop: true,
        speed: 700,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        slidesPerView: 'auto',
        pagination: {
            el: '.slider-timeline-dots',
            clickable: true
        },
        navigation: {
            prevEl: '.slider-timeline-prev',
            nextEl: '.slider-timeline-next'
        },
    });

    if (document.querySelector('.slider-gallery-grid')) {
        let sliderGalleryGrid;

        const enableSwiper = () => {
            sliderGalleryGrid = new Swiper('.slider-gallery-grid', {
                loop: true,
                speed: 700,
                loop: true,
                spaceBetween: 20,
                slidesPerView: 1.25,
                centeredSlides: true,
                navigation: {
                    prevEl: '.slider-gallery-grid-prev',
                    nextEl: '.slider-gallery-grid-next'
                }
            });
        }

        const disableSwiper = () => {
            if (sliderGalleryGrid) {
                sliderGalleryGrid.destroy(true, true);
                sliderGalleryGrid = undefined;
            }
        }

        const handleScreenSize = (e) => e.matches ? enableSwiper() : disableSwiper();

        handleScreenSize(mobileQuery);

        mobileQuery.addEventListener("change", handleScreenSize);
    }
});